export { default } from './CommentFormRWrapper';



// WEBPACK FOOTER //
// ./src/components/Comment/ReducerWrappers/CommentFormRWrapper/index.js